// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[v-cloak][data-v-78ecea64] {\n\tdisplay: none;\n}\n.controls[data-v-78ecea64] {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 11fr;\n\talign-items: center;\n}\n\n", ""]);
// Exports
module.exports = exports;
